import React from 'react'

import Text from '../../../../components/pdf/Text'
import View from '../../../../components/pdf/View'
import HeaderProforma from './sections/Header'
import FooterProforma from './sections/Footer'
import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import Separator from '../../../../components/pdf/Separator'
import Grid, { Col } from '../../../../components/pdf/Grid'
import { useReplies } from '../_load/ServiceOrderLoader'
import {
  filterRepliesByParentReference,
  findReplyByQuestionId,
  formatDollar,
  formatEnglishNumber,
  getRepliesFromBlockQuestion,
  getReplyValue,
  sumAmount
} from '../_helpers/pdfHelpers'

const ProformaPageContent = () => {
  const replies = useReplies()

  const shipTo = getReplyValue(findReplyByQuestionId(replies, 264))
  const shipToAddress = getReplyValue(findReplyByQuestionId(replies, 265))

  const productsBlock = () => {
    const blockReply = findReplyByQuestionId(replies, 271)
    const productsReplies = filterRepliesByParentReference(replies, blockReply?.question?.reference)

    const productsResult = {}
    productsReplies.forEach(productsReply => {
      const blockIndex = productsReply.blockIndex
      let productsData = productsResult[blockIndex]

      if (!productsData) {
        const blockReplies = getRepliesFromBlockQuestion(productsReplies, blockIndex)
        const quantity = getReplyValue(findReplyByQuestionId(blockReplies, 478))
        const unitPrice = getReplyValue(findReplyByQuestionId(blockReplies, 479))
        productsData = {
          item: (blockIndex + 1).toString().padStart(2, '0'),
          shipTo: getReplyValue(findReplyByQuestionId(blockReplies, 273)),
          itemNumber: getReplyValue(findReplyByQuestionId(blockReplies, 274)),
          description: getReplyValue(findReplyByQuestionId(blockReplies, 275)),
          quantity,
          unitPrice,
          total: quantity * unitPrice
        }
        productsResult[blockIndex] = productsData
      }
    })
    return Object.values(productsResult)
  }

  const products = productsBlock()

  const salesAmount = sumAmount(products, 'total')

  return (
    <>
      <View pageBreakAfter>
        <HeaderProforma />

        <Separator weight={20} />

        <Table width="100%" useFontBaseColor>
          <TableRow useFontBaseColor>
            <TableCol useFontBaseColor>
              <Text semibold>Line No.</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text semibold>Ship to*</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text semibold>Item Number</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text semibold>Description</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text semibold>Quantity</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text semibold>Unit Price</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text semibold>Amount</Text>
            </TableCol>
          </TableRow>
          {products.map((product, index) => (
            <TableRow useFontBaseColor key={index}>
              <TableCol useFontBaseColor>
                <Text>{product.item}</Text>
              </TableCol>
              <TableCol useFontBaseColor>
                <Text>{product.shipTo}</Text>
              </TableCol>
              <TableCol useFontBaseColor>
                <Text>{product.itemNumber}</Text>
              </TableCol>
              <TableCol useFontBaseColor>
                <Text>{product.description}</Text>
              </TableCol>
              <TableCol useFontBaseColor>
                <Text>{formatEnglishNumber(product.quantity)}</Text>
              </TableCol>
              <TableCol useFontBaseColor>
                <Text>{formatEnglishNumber(product.unitPrice)}</Text>
              </TableCol>
              <TableCol useFontBaseColor>
                <Text>{formatEnglishNumber(product.total)}</Text>
              </TableCol>
            </TableRow>
          ))}
        </Table>
        <Separator weight={20} />
        <Grid direction="column" align="end">
          <Col>
            <Table useFontBaseColor fixedLayout width="300px" style={{ border: 'none' }}>
              <TableRow useFontBaseColor style={{ borderTop: '1px solid #000' }}>
                <TableCol useFontBaseColor colspan="2" style={{ border: 'none' }}>
                  <Text>Sales Amount</Text>
                </TableCol>
                <TableCol useFontBaseColor style={{ border: 'none' }}>
                  <Text>{formatEnglishNumber(salesAmount)}</Text>
                </TableCol>
              </TableRow>
              <TableRow useFontBaseColor style={{ border: 'none' }}>
                <TableCol useFontBaseColor colspan="2" style={{ border: 'none' }}>
                  <Text>Misc. Charges</Text>
                </TableCol>
                <TableCol useFontBaseColor style={{ border: 'none' }}>
                  <Text>0.00</Text>
                </TableCol>
              </TableRow>
              <TableRow useFontBaseColor style={{ border: 'none' }}>
                <TableCol useFontBaseColor colspan="2" style={{ border: 'none' }}>
                  <Text>Discount</Text>
                </TableCol>
                <TableCol useFontBaseColor style={{ border: 'none' }}>
                  <Text>0.00</Text>
                </TableCol>
              </TableRow>
              <TableRow useFontBaseColor style={{ border: 'none' }}>
                <TableCol useFontBaseColor colspan="2" style={{ border: 'none' }}>
                  <Text>Sales Tax</Text>
                </TableCol>
                <TableCol useFontBaseColor style={{ border: 'none' }}>
                  <Text>0.00</Text>
                </TableCol>
              </TableRow>
              <TableRow useFontBaseColor style={{ borderBottom: '1px solid #000' }}>
                <TableCol useFontBaseColor colspan="2" style={{ border: 'none' }}>
                  <Text>Total</Text>
                </TableCol>
                <TableCol useFontBaseColor style={{ border: 'none' }}>
                  <Text>{formatEnglishNumber(salesAmount)}</Text>
                </TableCol>
              </TableRow>
              <TableRow useFontBaseColor style={{ borderBottom: '1px solid #000' }}>
                <TableCol useFontBaseColor colspan="2" style={{ border: 'none' }}>
                  <Text>Amount Received</Text>
                </TableCol>
                <TableCol useFontBaseColor style={{ border: 'none' }}>
                  <Text>{formatEnglishNumber(salesAmount)}</Text>
                </TableCol>
              </TableRow>
              <TableRow useFontBaseColor style={{ border: 'none' }}>
                <TableCol useFontBaseColor style={{ border: 'none' }}>
                  <Text semibold>BALANCE DUE</Text>
                </TableCol>
                <TableCol useFontBaseColor style={{ border: 'none' }}>
                  <Text semibold>USD</Text>
                </TableCol>
                <TableCol useFontBaseColor style={{ border: 'none' }}>
                  <Text semibold>1,350,000.00</Text>
                </TableCol>
              </TableRow>
            </Table>
          </Col>
        </Grid>

        <Separator weight={20} />

        <Grid gutter={10}>
          <Col gutter={10}>
            <Text semibold size="h5">
              Ship-to-address Legend*
            </Text>
          </Col>
          <Col gutter={10}>
            <Text>1</Text>
          </Col>
          <Col gutter={10}>
            <Text>{shipTo}</Text>
            <Text>{shipToAddress?.search}</Text>
          </Col>
        </Grid>
        <Separator weight={20} />

        <FooterProforma />
      </View>
    </>
  )
}

export default ProformaPageContent
